/* @ngInject */
const ask = (
  railwayData,
  railwayFormat,
  utils,
  railwayLocal,
  railwayLabels,
  toaster,
  valueHandler,
  railwayRequest
) => {
  const self = {}

  self.delete = async (_id, _back = false) => {
    if (valueHandler.isId(_id.id)) { _id = _id.id }

    if (toaster.confirm(railwayLabels.ask.delete)) {
      try {
        const message = await railwayRequest.delete(_id)

        toaster.message(message)
        utils.removeFromArray(railwayData.myRailways, _id)
        if (_back) {
          utils.$back()
        }
      } catch (error) {
        toaster.error(error)
      }
    }
  }

  self.update = async (_railway, _back = false) => {
    let railway = utils.copy(_railway)
    railway.id = railwayLocal.getCurrentId()
    railway = railwayFormat.server(railway)

    try {
      const response = await railwayRequest.update(railway)
      toaster.message(response.message)
      utils.updateFromArray(railwayData.myRailways, response.railway)
      if (_back) {
        utils.$back()
      }
    } catch (error) {
      toaster.error(error)
    }
  }

  return self
}

export default ask



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/ask.service.js